<template>
	<v-sheet flat class="ma-4">
		<v-row>
			<v-col>

				<ListSubpanel name=" " :rows="contracts" :headers="headers" class="mt-5" v-on:click="selectContract">
				</ListSubpanel>
				<p class="text-right">	
					<v-btn color="green" class="mr-4" dark @click="newContract"> New Contract </v-btn>
				</p>
				<v-sheet v-if="current">
					<ContractForm :contract="current" v-on:saved="$emit('saved')"></ContractForm>
					<v-dialog v-model="dialog" width="500">
						<v-card>
							<v-card-title>
								Delete Contract
							</v-card-title>
								<v-card-text>Are you sure?</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
										color="primary"
										text
										@click="deleteContract()"
										>
										Yes
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>	
					<p class="text-right">	
						<v-btn color="red" dark class="mr-4" @click="dialog = 1"> Delete Contract </v-btn>
					</p>
								
				</v-sheet>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<script>

	import Vuex from 'vuex'
	import ContractForm from "../forms/ContractForm.vue"
	import ListSubpanel from "../subpanels/ListSubpanel.vue"
	export default{
		name: "EditOrganisationContracts", 
		props: {
			organisation: {type: Object},
		},
		computed: {
			...Vuex.mapState({
				contracts: function(state){
					const self = this;
					let contracts = state.admin.contracts.filter( contract => contract.organisation == self.organisation.id) 
					return contracts;
				}
			})
		},
		data: () => {
			return {
				dialog: false,
				current: false,
				headers: [
					{text: "Name", value: "name"},
					{text: "Description", value: "description"},
					{text: "Start", value: "startDate"},
					{text: "End", value: "endDate"},
					{text: "", value: "clickEdit"},
				]
			}
		},
		components: {
			ContractForm: ContractForm,
			ListSubpanel: ListSubpanel,
		},
		methods:{
			selectContract(item){
				this.current = item;
			},
			deleteContract(){
				const self = this;
				let contract = this.current;
				let index = this.contracts.indexOf( contract )
				this.$store.dispatch("updateDoc", {
					doc: "contracts/" + contract.id, 
					data: false,
					action: "delete"
				}).then( () => {
					self.contracts.splice( index, 1 )
					self.dialog = false;
				})
			},
			newContract(){
				let contract = {
					organisation: this.organisation.id
				}
				this.$store.dispatch("addDoc", {
					collection: "contracts", 
					data: contract
				}).then( (ref) => {
					contract.id = ref.id
					this.current = contract;
				})	
			}
		} 
	}
</script>